import { Chip, Icon, Text } from '@ui-component-library';

const subscriptionData = {
  title: 'Treebula Plus (förnyas årligen)',
  description:
    'Med Treebula Plus får du <b>full kontroll</b> över din skog och <b>nya möjligheter</b> att skapa värde. Du får en <b>smart, trygg</b> och <b>aktuell</b> helhetslösning som hjälper dig att <b>maximera lönsamheten</b> och fatta <b>välgrundade beslut</b> för din fastighets framtid.',
  featureTitle: 'Som Pluskund får du bland annat:',
  features: [
    'Komplett digital skogsbruksplan',
    'Fullständig tillgång till prisjämförelse på virke',
    'Skogsövervakning',
    'Fastighetsvärdering',
    'Marknadsinformation och notiser'
  ]
};

const getRenewalDate = (): string => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date.toLocaleDateString('sv-SE');
};

export const SubscriptionInfo = () => {
  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col gap-4">
      <div
          id="subscription-0"
          className="bg-white-50 flex w-full flex-col gap-2 rounded-xl border border-[#E5E5E5] p-4"
        >
          <div className="mb-4 flex flex-col gap-2">
            <div className="flex flex-row items-baseline justify-between gap-2">
              <Text variant="text-base/leading-normal/medium" className="text-charcoal-500">
                {subscriptionData.title}
              </Text>
              <Chip label="Rekommenderas" icon="PlusSimple" className="bg-[#F5F5F5]" />
            </div>
            <p
              className="leading-sm text-sm font-normal tracking-wide"
              dangerouslySetInnerHTML={{ __html: subscriptionData.description }}
            />
          </div>
          <div className="mb-6 flex h-full flex-col items-start gap-3">
            <Text variant="text-sm/leading-normal/medium">{subscriptionData.featureTitle}</Text>
            {subscriptionData.features.map((feature, index) => (
              <div key={index} className="flex w-full flex-row items-center justify-between gap-3">
                <div className="flex flex-row items-center gap-3">
                  <Icon name="CheckSimple" size="medium" className="text-charcoal-500" />
                  <Text variant="text-sm/leading-normal/normal" className="text-charcoal-500">
                    {feature}
                  </Text> 
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          id="subscription-1"
          className="bg-white-50 flex w-full flex-col gap-2 rounded-xl border border-[#E5E5E5] p-4"
        >
          <div className="mb-4 flex flex-col gap-2">
            <Text variant="text-sm/leading-normal/medium">Automatisk förnyelse</Text>
            <Text variant="text-sm/leading-normal/normal" className="text-charcoal-500">
              Din prenumeration är löpande och förnyas automatiskt varje år. Prenumerationen kan avslutas när som helst via din profil innan nästa förnyelse ({getRenewalDate()}).
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
